import * as React from 'react';
import ChangeHighlight from 'react-change-highlight';
import { ScoreBadge } from './ScoreBadge';
import { useTheme } from '../utils/ThemeContext';

export default function ScoreCardTable({ scores, course, highlight = false, highlightHole = null }) {
  const { theme } = useTheme();
  const refs = React.useRef([0,1,2,3,4,5,6,7,8,9].map(() => React.createRef()));

  const renderScore = (idx) => {
    const par = idx < 9 ? course[`par_${idx + 1}`] : null;
    const content = idx < 9
      ? <ScoreBadge score={scores[idx]} par={par} />
      : <span>{scores[idx]}</span>;

    if (highlight) {
      return (
        <ChangeHighlight showAfter={0} hideAfter={750}>
          <span ref={refs.current[idx]}>{content}</span>
        </ChangeHighlight>
      );
    }
    return content;
  };

  const cellStyle = { padding: '4px 2px', textAlign: 'center', fontSize: '12px' };
  const labelStyle = { padding: '4px 6px', textAlign: 'left', fontWeight: 'bold', color: theme.primary, fontSize: '12px', whiteSpace: 'nowrap', width: '44px' };

  return (
    <div style={{ overflowX: 'auto', width: '100%', boxSizing: 'border-box' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', tableLayout: 'fixed' }}>
        <tbody>
          <tr style={{ backgroundColor: theme.primary, color: '#fff', fontWeight: 'bold' }}>
            <td style={{ ...cellStyle, textAlign: 'left', paddingLeft: '6px', color: '#fff', width: '44px' }}>Hole</td>
            {[1,2,3,4,5,6,7,8,9].map((n) => <td key={n} style={{ ...cellStyle, color: '#fff' }}>{n}</td>)}
            <td style={{ ...cellStyle, color: '#fff' }}>Tot</td>
          </tr>
          <tr style={{ backgroundColor: theme.rowBg }}>
            <td style={labelStyle}>Score</td>
            {[0,1,2,3,4,5,6,7,8,9].map((i) => (
              <td key={i} style={{
                ...cellStyle,
                transition: 'background-color 0.4s ease',
                backgroundColor: highlightHole === i ? '#64b5f6' : '',
              }}>{renderScore(i)}</td>
            ))}
          </tr>
          <tr style={{ backgroundColor: theme.rowBgAlt }}>
            <td style={labelStyle}>Par</td>
            {[1,2,3,4,5,6,7,8,9].map((n) => (
              <td key={n} style={cellStyle}><span>{course[`par_${n}`]}</span></td>
            ))}
            <td style={cellStyle}><span>{course.par}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
